// AI Generated Test
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { ComponentDetailsViewService } from '@client/app/blocks/service/component-details-view.service';

@Component({
    selector: 'table-document-details',
    standalone: false,
    template: `
        <div [attr.aria-label]="labelMsg"
             (click)="gotoDocumentDetails()"
             tabindex="0"
             *ngIf="hasAccessToDetailsOverlay"
             role="button"
             class="btn btn-secondary">
            <span
                [ngClass]="['TABLES', 'PAGEDETAILS'] | monIcons"
                aria-hidden="true">
            </span>
        </div>
    `,
})
export class TableDocumentDetailsComponent implements OnInit {
    @Input() document: any;
    @Input() target?: string | undefined;
    @Input() subTarget?: any | undefined;

    @Output() callBack = new EventEmitter<any>();

    labelMsg: string = '';
    hasAccessToDetailsOverlay: boolean = false;

    constructor (
        private translateService: TranslateService,
        private componentDetailsViewService: ComponentDetailsViewService,
        private activeFeatureService: ActiveFeatureService,
    ) { }

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.labelMsg = this.translateService.getString('Open Document details', {}, 'Aria label when clicking on open Document details');
        this.hasAccessToDetailsOverlay = this.activeFeatureService.isFeatureActive('page_details');
    }

    gotoDocumentDetails (): void {
        const params = {
            target: this.target,
            subTarget: this.subTarget,
        };
        this.componentDetailsViewService.goToDocumentDetails(this.document, params, () => {
            this.callBack.emit();
        });

    }
}
